var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgFile = function SvgFile(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M.85 15.684V1.816C.85.87 1.619.1 2.566.1h10.7c.447 0 .877.175 1.198.488l2.101 2.05c.33.323.518.766.518 1.23v11.816c0 .948-.769 1.716-1.717 1.716h-12.8A1.717 1.717 0 0 1 .85 15.684m1.3 0c0 .23.186.415.416.416h12.8c.23 0 .417-.186.417-.416V3.867a.4.4 0 0 0-.072-.234l-.054-.065-2.1-2.05a.4.4 0 0 0-.211-.11l-.08-.008h-10.7a.416.416 0 0 0-.416.416z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "m13.265 5.433.131.014a.65.65 0 0 1 0 1.273l-.13.014H4.731a.65.65 0 0 1 0-1.301zM13.265 8.633l.131.014a.65.65 0 0 1 0 1.273l-.13.014H4.731a.65.65 0 0 1 0-1.301zM8.999 11.833l.13.014a.65.65 0 0 1 0 1.273l-.13.014H4.732a.65.65 0 0 1 0-1.301z"
  })));
};
export default SvgFile;